import * as React from "react";

import { DatePicker, RadioGroup, TextField } from "../../../Base/Fields";
import { constants } from "../../../../../store/marketIndpAds";

import { buildQueryString } from "../../../../../store/base";
import useActiveFilters from "../../../../../hooks/useActiveFilters";
import {
  OverviewSubtitle,
  OverviewTitle,
  OverviewTitleWithSubtitleWrapper,
  OverviewTitleWrapper,
} from "../../../../Details/OverviewInfo/styles";
import TableSelectField from "src/components/Forms/Base/Fields/TableSelectField";
import IndustrialPremisesTable from "src/components/Tables/IndustrialPremises/FullTableNewVersion";

export default ({ method, hideIndp }) => {
  const { filteredRealEstates } = useActiveFilters();
  const storeName = constants.STORE_NAME;

  const indpQuery = buildQueryString({
    realestate_ids: filteredRealEstates,
  });

  const indpFilter = (obj) => {
    if (!filteredRealEstates) return obj;

    return filteredRealEstates.includes(obj.realestate.id);
  };

  return (
    <>
      <OverviewTitleWrapper>
        <OverviewTitleWithSubtitleWrapper>
          <OverviewTitle>Annonsinställningar</OverviewTitle>
          <OverviewSubtitle>
            Ställ in hur annonsen ska se ut och fungera
          </OverviewSubtitle>
        </OverviewTitleWithSubtitleWrapper>
      </OverviewTitleWrapper>

      <hr />

      {!hideIndp && (
        <div className="grid grid-cols-2 gap-6 mb-6">
          <TableSelectField
            storeName={storeName}
            method={method}
            fieldKey="industrial_premises"
            TableComponent={IndustrialPremisesTable}
            persistantQuery={{
              realestate_ids: filteredRealEstates,
            }}
            title="Lokal annons gäller för"
            placeholder="Välj lokal..."
          />
        </div>
      )}

      <DatePicker
        fieldKey="date_publish"
        title="Publiceringsdatum"
        {...{ storeName, method }}
      />

      <TextField
        title="Annonsbeskrivning"
        description="Denna beskrivning kommer tillsammans med bilder på objektet samt annonsdetaljerna publiceras på aktiva annonsplatser"
        {...{ storeName, method }}
        fieldKey="description"
      />

      <RadioGroup
        extraStyles={{ flex: 1 }}
        fieldKey="is_pending"
        title="Pausad"
        options={[
          { label: "Ja", value: true },
          { label: "Nej", value: false },
        ]}
        defaultValue={false}
        {...{ storeName, method }}
      />
    </>
  );
};
